import { site } from '@panel/commons/helpers';
import * as types from './types';

const planWeight = {
  SUPERHIGHLIGHTED: 4,
  HIGHLIGHTED: 3,
  SIMPLE: 2,
  FREE: 1
};

const initialState = {
  availablePlans: [],
  credits: null,
  freeAvailable: false,
  currentPlan: null,
  products: [],
  eligibleForUpgrade: false,
  creditCompleted: false
};

function step4Module1Reducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_PRODUCTS_COMPLETED:
      // LOS PRODUCTOS SE ORDENAN POR DESTAQUE
      action.payload.sort((a, b) => {
        if (planWeight[a.type] < planWeight[b.type]) {
          return 1;
        }
        if (planWeight[a.type] > planWeight[b.type]) {
          return -1;
        }
        return 0;
      });

      return {
        ...state,
        products: action.payload,
        errorProducts: false
      };
    case types.GET_PRODUCTS_FAILED:
      return {
        ...state,
        errorProducts: true
      };
    case types.GET_CREDITS_COMPLETED:
      if (action.payload.availablePlans.length > 0) {
        // LOS PLANES SE ORDENAN POR DESTAQUE
        action.payload.availablePlans.sort((a, b) => {
          if (
            planWeight[a.publicationPlan.publication_areas[0].publication_type] <
            planWeight[b.publicationPlan.publication_areas[0].publication_type]
          ) {
            return 1;
          }
          if (
            planWeight[a.publicationPlan.publication_areas[0].publication_type] >
            planWeight[b.publicationPlan.publication_areas[0].publication_type]
          ) {
            return -1;
          }
          return 0;
        });

        // SI EXISTE PLAN VIGENTE (EDICIÓN) SE BUSCA ENTRE LOS DISPONIBLES PARA MARCARLO COMO VIGENTE Y SELECCIONADO
        if (action.payload.currentPlan) {
          action.payload.availablePlans = action.payload.availablePlans.map(p => {
            if (p.publicationPlan.publication_plan_id === action.payload.currentPlan.publication_plan_id) {
              p.selected = true;
              p.isCurrent = true;
            } else {
              p.isCurrent = false;
              p.selected = false;
            }
            return p;
          });
          action.payload.availablePlans.sort((a, b) => {
            if (a.isCurrent < b.isCurrent) {
              return 1;
            }
            if (a.isCurrent > b.isCurrent) {
              return -1;
            }
            return 0;
          });
          // SI NO SE ENCONTRÓ ENTRE LOS DISPONIBLES SE AGREGA EL VIGENTE AL ARREGLO
          if (!action.payload.availablePlans.some(p => p.isCurrent)) {
            action.payload.currentPlan.selected = true;
            action.payload.currentPlan.isCurrent = true;
            action.payload.currentPlan.publicationPlan = {
              publication_plan_id: action.payload.currentPlan.publication_plan_id,
              publication_areas: action.payload.currentPlan.publication_areas
            };
            action.payload.availablePlans.unshift(action.payload.currentPlan);
          }
        } else {
          action.payload.availablePlans.map((p, i) => {
            p.selected = i === 0;
            return p;
          });
        }
      } else if (action.payload.currentPlan) {
        // SI NO HABÍA PLANES DISPONIBLES, DE HABER UN VIGENTE, SE AGREGA AL ARREGLO
        action.payload.currentPlan.selected = true;
        action.payload.currentPlan.isCurrent = true;
        action.payload.currentPlan.publicationPlan = {
          publication_plan_id: action.payload.currentPlan.publication_plan_id,
          publication_areas: action.payload.currentPlan.publication_areas
        };
        action.payload.availablePlans.unshift(action.payload.currentPlan);
      }

      return {
        ...state,
        availablePlans: action.payload.availablePlans,
        freeAvailable: site.isEcuador || site.isPanama ? null : action.payload.hasFreePlanAvailable,
        errorCredits: false,
        currentPlan: action.payload.currentPlan,
        eligibleForUpgrade: action.payload.eligibleForUpgrade,
        creditsCompleted: true
      };
    case types.GET_CREDITS_FAILED:
      return {
        ...state,
        errorCredits: true
      };
    case types.SELECT_PLAN:
      return {
        ...state,
        availablePlans: state.availablePlans.map(p => {
          p.selected = p.publicationPlan.publication_plan_id === action.payload;
          return p;
        })
      };
    case types.BUY_FREEMIUM_COMPLETED:
      return {
        ...state,
        freeResponse: true,
        freeError: false
      };
    case types.BUY_FREEMIUM_FAILED:
      return {
        ...state,
        freeResponse: null,
        freeError: true
      };
    case types.CLEAN_RESPONSE:
      return {
        ...state,
        [action.payload]: false
      };
    default:
      return state;
  }
}

export { step4Module1Reducer };
